// src/i18n/broadcast.ts —— 06 admin-console C-33 Bot 广告推送文案包（0049；经 dash 域 i18n 挂入字典）。键统一 bc 前缀（个人设置 Telegram 数字 ID 为 myTg 前缀），
// 与原型字典不重名（无 rewrites）。状态 / run 状态 / 失败类型 / 投递状态键名按 bcSt* / bcRun* / bcFk* / bcDs* + 驼峰值拼接（dash.broadcast 映射）。
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_BROADCAST: I18nPack = {
  zh: {
    bcNote: '只向主动私聊过所选 Bot、未退订（/stop_ads）且未拉黑的用户发送；每条消息自动附加退订尾注。上线初期「私聊过」记录由历史通知 Bot 与充值订单回填，覆盖可能偏少，用户再次与 Bot 互动后自动纳入。',
    // ---- 列表 ----
    bcFStatus: '状态',
    bcFOwner: '来源',
    bcFBot: 'Bot',
    bcPendingBtn: '待审核 {n}',
    bcNew: '新建推送',
    bcSettings: '推送设置',
    bcRefresh: '刷新',
    bcCTitle: '名称',
    bcCSource: '来源',
    bcCBots: 'Bot',
    bcCRule: '时间规则',
    bcCStatus: '状态',
    bcCNext: '下一次执行',
    bcCLast: '最近一次（成功 / 目标）',
    bcLastRun: '{sent} / {total}（失败 {failed} · 跳过 {skipped}）',
    bcOwnerAdmin: '平台',
    bcOwnerAgent: '代理',
    bcPager: '第 {p} / {n} 页 · 共 {total} 条',
    bcBackList: '返回列表',
    bcBackDetail: '返回活动详情',
    bcBackCancel: '放弃编辑',
    bcLoading: '加载中…',
    // ---- 状态 ----
    bcStDraft: '草稿',
    bcStPendingReview: '待审核',
    bcStRejected: '已驳回',
    bcStScheduled: '已排期',
    bcStPaused: '已暂停',
    bcStDone: '已完成',
    bcStCancelled: '已取消',
    bcRunQueued: '排队中',
    bcRunSnapshotting: '圈选受众中',
    bcRunSending: '发送中',
    bcRunPaused: '已暂停',
    bcRunDone: '已完成',
    bcRunCancelled: '已取消',
    bcRunFailed: '失败',
    bcFkBlocked: '已拉黑',
    bcFkNotFound: '未找到',
    bcFkOther: '其他',
    bcFkRejected: '被拒绝',
    bcFkBotInactive: 'Bot 不可用',
    bcFkTransient: '临时失败 / 状态未知',
    bcFkPartial: '部分发送',
    bcDsPending: '待发送',
    bcDsSending: '发送中',
    bcDsSent: '已发送',
    bcDsFailed: '失败',
    bcDsSkipped: '已跳过',
    // ---- 编辑器 ----
    bcEditTitle: '编辑推送 #{id}',
    bcReEditTip: '已排期的活动保存后回到草稿，需重新提交才会继续执行。',
    bcLTitle: '内部名称（不下发，≤64 字）',
    bcLBots: '发送 Bot',
    bcBotCount: '已选 {n} / {max}',
    bcPlatformBots: '平台 Bot',
    bcAgentBots: '代理 Bot · {name}',
    bcStaleBots: '已选但当前不可用',
    bcLCard: '持卡筛选',
    bcCardAny: '不限',
    bcCardHas: '有有效卡',
    bcCardNone: '无有效卡',
    bcLLang: '语言筛选',
    bcLangAny: '不限',
    bcLangZh: '中文用户',
    bcLangEn: '英文用户',
    bcLTextZh: '中文文案（必填）',
    bcLTextEn: '英文文案（留空则英文用户收中文）',
    bcTagHint: '支持 <b>粗体</b> <i>斜体</i> <u>下划线</u> <s>删除线</s> <code>代码</code> <a href="https://…">链接</a>；其他标签按原文显示。计数含退订尾注（英文文案留空时按较长的英文尾注计）：带图 ≤1024，无图 ≤4096。',
    bcCount: '{n} / {max}',
    bcPrevZh: '中文预览',
    bcPrevEn: '英文预览',
    bcLImage: '图片（可选）',
    bcImgHint: 'JPG / PNG / WebP，≤5 MB；带图时文案上限 1024',
    bcDelImg: '移除图片',
    bcLButtons: '按钮（最多 3 个，每个一行）',
    bcAddBtn: '添加按钮',
    bcBtnMax: '最多 {n} 个按钮',
    bcBtnUrl: '链接',
    bcBtnWebapp: '打开 Mini App',
    bcBtnLabelZh: '按钮文案（中）',
    bcBtnLabelEn: '按钮文案（EN）',
    bcBtnUrlPh: 'https://…（t.me 仅限公开用户名）',
    bcLSchedule: '发送时间',
    bcKindNow: '立即发送',
    bcKindOnce: '定时一次',
    bcKindDaily: '每天',
    bcKindWeekly: '每周',
    bcLRunAt: '发送时刻',
    bcLTime: '每次发送时刻（HH:MM）',
    bcLEndDate: '结束日期（含，可选）',
    bcLWeekdays: '星期',
    bcWeekdays: ['一', '二', '三', '四', '五', '六', '日'],
    bcSep: '、',
    bcUntil: '，至 {d}',
    bcTz: '时区：{tz}（{off}）',
    bcLEstimate: '预估人数',
    bcEstimate: '预估人数',
    bcEstimating: '预估中…',
    bcEstTotal: '预计送达 {n} 人（按发送时刻实际名单为准）',
    bcEstCapped: '已超过单次目标上限，执行时将截断。',
    bcSave: '保存',
    bcSaving: '保存中…',
    bcPreview: '发给我预览',
    bcPreviewing: '发送中…',
    bcPreviewTip: '预览发到你在个人设置中填写的 Telegram 数字 ID（使用所选第一个 Bot）；请先在该 Bot 发送 /start。',
    // ---- 详情 ----
    bcActEdit: '编辑',
    bcActSubmit: '提交',
    bcActApprove: '审核通过',
    bcActReject: '驳回',
    bcActPause: '暂停',
    bcActResume: '继续',
    bcActCancel: '取消活动',
    bcSubmitTitle: '提交推送',
    bcSubmitText: '提交后按排期自动执行；代理活动在审核通过后才会执行。',
    bcSubmitNowText: '「立即发送」的活动提交后会马上开始圈选受众并发送，确认继续？',
    bcCancelTitle: '取消推送活动',
    bcCancelText: '取消后不再执行；正在发送的批次会停止，未发送的用户全部跳过。此操作不可恢复。',
    bcRejectTip: '驳回原因会展示给提交该活动的代理。',
    bcRejectNote: '驳回原因',
    bcRejectPh: '例如：链接指向非官方站点',
    bcRejectedNote: '驳回原因：{note}',
    bcReviewNote: '审核备注：{note}',
    bcFSource: '来源',
    bcFBots: 'Bot',
    bcFFilter: '受众筛选',
    bcFSchedule: '时间规则',
    bcFNext: '下一次执行',
    bcFTz: '时区',
    bcFCreated: '创建时间',
    bcFUpdated: '更新时间',
    bcFButtons: '按钮',
    bcRuns: '执行记录',
    bcCPlanned: '计划时刻',
    bcCTarget: '目标人数',
    bcCSent: '已发送',
    bcCFailed: '失败',
    bcCSkipped: '跳过',
    bcCFinished: '结束时间',
    bcTruncated: '（已截断）',
    bcView: '查看',
    // ---- run 详情 ----
    bcRunTitle: '执行 #{id} · {planned}',
    bcPolling: '每 5 秒自动刷新',
    bcProgress: '已处理 {done} / {total}',
    bcTruncatedTip: '目标人数超过单次上限，已按上限截断。',
    bcRunTimes: '开始 {s} · 结束 {f}',
    bcFails: '送达明细',
    bcTabAll: '全部失败',
    bcTabBlocked: '拉黑',
    bcTabNotFound: '未找到',
    bcTabSkipped: '已跳过',
    bcCUser: '用户',
    bcCBot: 'Bot',
    bcCDStatus: '状态',
    bcCKind: '失败类型',
    bcCDesc: '说明',
    bcCAt: '时间',
    bcEmpty: '暂无记录',
    // ---- 设置 ----
    bcSettingsTip: '代理群发总开关默认关闭；开启后代理活动默认需平台审核。速率为每秒条数。',
    bcSettingsRo: '无编辑权限，仅可查看。',
    bcSetAgentEnabled: '允许代理群发',
    bcSetAgentReview: '代理活动需审核',
    bcSetDaily: '代理每 Bot 每日次数',
    bcSetMaxTargets: '代理单次目标上限',
    bcSetMaxPeriodic: '代理进行中周期活动上限',
    bcSetPerBotRate: '每 Bot 速率（条/秒）',
    bcSetGlobalRate: '全局速率（条/秒）',
    bcOn: '开启',
    bcOff: '关闭',
    // ---- 提示 ----
    bcToastSaved: '已保存',
    bcToastPreview: '预览已发送，请在 Telegram 查看',
    bcToastSubmitted: '已提交',
    bcToastPaused: '已暂停',
    bcToastResumed: '已继续',
    bcToastCancelled: '活动已取消',
    bcToastApproved: '已审核通过',
    bcToastRejected: '已驳回',
    bcToastSettings: '推送设置已保存',
    bcErrTitle: '请填写内部名称（≤64 字）',
    bcErrBots: '请至少选择一个 Bot',
    bcErrBotsMax: '最多选择 {n} 个 Bot',
    bcErrTextZh: '请填写中文文案',
    bcErrTooLong: '文案（含退订尾注）超出长度上限：带图 1024 / 无图 4096',
    bcErrBtnLabel: '请填写按钮中文文案',
    bcErrUrl: '按钮链接格式不正确',
    bcErrUrlHttps: '按钮链接只允许 https://',
    bcErrUrlTme: 't.me 链接只允许公开用户名（不支持邀请链接）',
    bcErrRunAt: '请选择发送时刻',
    bcErrTime: '请填写发送时刻（HH:MM），结束日期格式为 YYYY-MM-DD',
    bcErrWeekdays: '请至少选择一个星期',
    bcErrImgType: '图片只支持 JPG / PNG / WebP',
    bcErrImgSize: '图片不能超过 5 MB',
    bcErrNoteMax: '驳回原因不超过 {n} 字',
    bcErrSettings: '数值须为非负整数，速率至少为 1',
    bcErrNoTg: '请先在左下角「Telegram ID」填写你的 Telegram 数字 ID',
    bcErrPreviewBlocked: '预览发送失败：请先在所选 Bot 中发送 /start 后重试',
    bcErrStatus: '当前状态不允许此操作，请刷新后重试',
    bcErrStale: '活动已被他人修改，已刷新为最新内容',
    // ---- 个人设置：Telegram 数字 ID ----
    myTg: 'Telegram ID',
    myTgTitle: '个人设置 · Telegram 数字 ID',
    myTgTip: '用于接收广告推送的「发给我预览」。填写你的 Telegram 数字 ID（可在 Telegram 向 @userinfobot 发送任意消息获取），并先在要预览的 Bot 中发送 /start。留空保存即解除。',
    myTgLabel: 'Telegram 数字 ID',
    myTgPh: '例如 123456789',
    myTgErr: 'Telegram 数字 ID 只能是 5–20 位数字',
    myTgSaved: 'Telegram 数字 ID 已保存',
    myTgCleared: 'Telegram 数字 ID 已解除',
  },
  en: {
    bcNote: 'Only users who have privately chatted with the selected bots, have not opted out (/stop_ads) and have not blocked the bot receive it; an unsubscribe footer is appended to every message. At launch the chat records are backfilled from notification bots and top-up orders, so coverage may be low; users are added once they interact with the bot again.',
    bcFStatus: 'Status',
    bcFOwner: 'Source',
    bcFBot: 'Bot',
    bcPendingBtn: 'Pending review {n}',
    bcNew: 'New broadcast',
    bcSettings: 'Broadcast settings',
    bcRefresh: 'Refresh',
    bcCTitle: 'Name',
    bcCSource: 'Source',
    bcCBots: 'Bots',
    bcCRule: 'Schedule',
    bcCStatus: 'Status',
    bcCNext: 'Next run',
    bcCLast: 'Last run (sent / target)',
    bcLastRun: '{sent} / {total} (failed {failed} · skipped {skipped})',
    bcOwnerAdmin: 'Platform',
    bcOwnerAgent: 'Agent',
    bcPager: 'Page {p} / {n} · {total} total',
    bcBackList: 'Back to list',
    bcBackDetail: 'Back to campaign',
    bcBackCancel: 'Discard changes',
    bcLoading: 'Loading…',
    bcStDraft: 'Draft',
    bcStPendingReview: 'Pending review',
    bcStRejected: 'Rejected',
    bcStScheduled: 'Scheduled',
    bcStPaused: 'Paused',
    bcStDone: 'Done',
    bcStCancelled: 'Cancelled',
    bcRunQueued: 'Queued',
    bcRunSnapshotting: 'Selecting audience',
    bcRunSending: 'Sending',
    bcRunPaused: 'Paused',
    bcRunDone: 'Done',
    bcRunCancelled: 'Cancelled',
    bcRunFailed: 'Failed',
    bcFkBlocked: 'Blocked',
    bcFkNotFound: 'Not found',
    bcFkOther: 'Other',
    bcFkRejected: 'Rejected',
    bcFkBotInactive: 'Bot unavailable',
    bcFkTransient: 'Transient / unknown',
    bcFkPartial: 'Partially sent',
    bcDsPending: 'Pending',
    bcDsSending: 'Sending',
    bcDsSent: 'Sent',
    bcDsFailed: 'Failed',
    bcDsSkipped: 'Skipped',
    bcEditTitle: 'Edit broadcast #{id}',
    bcReEditTip: 'Saving a scheduled campaign returns it to draft; submit it again to resume.',
    bcLTitle: 'Internal name (not sent, ≤64 chars)',
    bcLBots: 'Sending bots',
    bcBotCount: '{n} / {max} selected',
    bcPlatformBots: 'Platform bots',
    bcAgentBots: 'Agent bots · {name}',
    bcStaleBots: 'Selected but unavailable',
    bcLCard: 'Card filter',
    bcCardAny: 'Any',
    bcCardHas: 'Has an active card',
    bcCardNone: 'No active card',
    bcLLang: 'Language filter',
    bcLangAny: 'Any',
    bcLangZh: 'Chinese users',
    bcLangEn: 'English users',
    bcLTextZh: 'Chinese text (required)',
    bcLTextEn: 'English text (empty = English users get the Chinese text)',
    bcTagHint: 'Supports <b>bold</b> <i>italic</i> <u>underline</u> <s>strike</s> <code>code</code> <a href="https://…">link</a>; other tags are shown as plain text. Count includes the unsubscribe footer (the longer English footer when English text is empty): ≤1024 with image, ≤4096 without.',
    bcCount: '{n} / {max}',
    bcPrevZh: 'Chinese preview',
    bcPrevEn: 'English preview',
    bcLImage: 'Image (optional)',
    bcImgHint: 'JPG / PNG / WebP, ≤5 MB; text limit becomes 1024 with an image',
    bcDelImg: 'Remove image',
    bcLButtons: 'Buttons (up to 3, one per row)',
    bcAddBtn: 'Add button',
    bcBtnMax: 'Up to {n} buttons',
    bcBtnUrl: 'Link',
    bcBtnWebapp: 'Open Mini App',
    bcBtnLabelZh: 'Button text (ZH)',
    bcBtnLabelEn: 'Button text (EN)',
    bcBtnUrlPh: 'https://… (t.me public usernames only)',
    bcLSchedule: 'When to send',
    bcKindNow: 'Send now',
    bcKindOnce: 'Once at',
    bcKindDaily: 'Daily',
    bcKindWeekly: 'Weekly',
    bcLRunAt: 'Send at',
    bcLTime: 'Time of day (HH:MM)',
    bcLEndDate: 'End date (inclusive, optional)',
    bcLWeekdays: 'Weekdays',
    bcWeekdays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    bcSep: ', ',
    bcUntil: ', until {d}',
    bcTz: 'Time zone: {tz} ({off})',
    bcLEstimate: 'Audience estimate',
    bcEstimate: 'Estimate audience',
    bcEstimating: 'Estimating…',
    bcEstTotal: 'About {n} recipients (the final list is taken at send time)',
    bcEstCapped: 'Exceeds the per-run target cap; the run will be truncated.',
    bcSave: 'Save',
    bcSaving: 'Saving…',
    bcPreview: 'Send me a preview',
    bcPreviewing: 'Sending…',
    bcPreviewTip: 'The preview goes to the Telegram numeric ID in your profile settings via the first selected bot; send /start to that bot first.',
    bcActEdit: 'Edit',
    bcActSubmit: 'Submit',
    bcActApprove: 'Approve',
    bcActReject: 'Reject',
    bcActPause: 'Pause',
    bcActResume: 'Resume',
    bcActCancel: 'Cancel campaign',
    bcSubmitTitle: 'Submit broadcast',
    bcSubmitText: 'Runs automatically on schedule after submission; agent campaigns run only after approval.',
    bcSubmitNowText: 'A "Send now" campaign starts selecting recipients and sending right after submission. Continue?',
    bcCancelTitle: 'Cancel broadcast campaign',
    bcCancelText: 'The campaign will not run again; an in-progress run stops and remaining recipients are skipped. This cannot be undone.',
    bcRejectTip: 'The reason is shown to the agent who submitted the campaign.',
    bcRejectNote: 'Reason',
    bcRejectPh: 'e.g. link points to an unofficial site',
    bcRejectedNote: 'Rejected: {note}',
    bcReviewNote: 'Review note: {note}',
    bcFSource: 'Source',
    bcFBots: 'Bots',
    bcFFilter: 'Audience filter',
    bcFSchedule: 'Schedule',
    bcFNext: 'Next run',
    bcFTz: 'Time zone',
    bcFCreated: 'Created',
    bcFUpdated: 'Updated',
    bcFButtons: 'Buttons',
    bcRuns: 'Runs',
    bcCPlanned: 'Planned at',
    bcCTarget: 'Target',
    bcCSent: 'Sent',
    bcCFailed: 'Failed',
    bcCSkipped: 'Skipped',
    bcCFinished: 'Finished',
    bcTruncated: '(truncated)',
    bcView: 'View',
    bcRunTitle: 'Run #{id} · {planned}',
    bcPolling: 'Auto-refresh every 5 s',
    bcProgress: 'Processed {done} / {total}',
    bcTruncatedTip: 'The audience exceeded the per-run cap and was truncated.',
    bcRunTimes: 'Started {s} · Finished {f}',
    bcFails: 'Delivery details',
    bcTabAll: 'All failed',
    bcTabBlocked: 'Blocked',
    bcTabNotFound: 'Not found',
    bcTabSkipped: 'Skipped',
    bcCUser: 'User',
    bcCBot: 'Bot',
    bcCDStatus: 'Status',
    bcCKind: 'Failure type',
    bcCDesc: 'Detail',
    bcCAt: 'Time',
    bcEmpty: 'No records',
    bcSettingsTip: 'Agent broadcasts are off by default; when enabled, agent campaigns require platform review by default. Rates are messages per second.',
    bcSettingsRo: 'Read-only: you do not have edit permission.',
    bcSetAgentEnabled: 'Allow agent broadcasts',
    bcSetAgentReview: 'Agent campaigns need review',
    bcSetDaily: 'Agent runs per bot per day',
    bcSetMaxTargets: 'Agent per-run target cap',
    bcSetMaxPeriodic: 'Agent active recurring campaigns cap',
    bcSetPerBotRate: 'Per-bot rate (msg/s)',
    bcSetGlobalRate: 'Global rate (msg/s)',
    bcOn: 'On',
    bcOff: 'Off',
    bcToastSaved: 'Saved',
    bcToastPreview: 'Preview sent, check Telegram',
    bcToastSubmitted: 'Submitted',
    bcToastPaused: 'Paused',
    bcToastResumed: 'Resumed',
    bcToastCancelled: 'Campaign cancelled',
    bcToastApproved: 'Approved',
    bcToastRejected: 'Rejected',
    bcToastSettings: 'Broadcast settings saved',
    bcErrTitle: 'Enter an internal name (≤64 chars)',
    bcErrBots: 'Select at least one bot',
    bcErrBotsMax: 'Select at most {n} bots',
    bcErrTextZh: 'Enter the Chinese text',
    bcErrTooLong: 'Text (incl. unsubscribe footer) is too long: 1024 with image / 4096 without',
    bcErrBtnLabel: 'Enter the Chinese button text',
    bcErrUrl: 'Invalid button link',
    bcErrUrlHttps: 'Button links must use https://',
    bcErrUrlTme: 't.me links must be public usernames (invite links are not allowed)',
    bcErrRunAt: 'Pick the send time',
    bcErrTime: 'Enter the time of day (HH:MM); end date format is YYYY-MM-DD',
    bcErrWeekdays: 'Select at least one weekday',
    bcErrImgType: 'Only JPG / PNG / WebP images are supported',
    bcErrImgSize: 'Image must not exceed 5 MB',
    bcErrNoteMax: 'Reason must be at most {n} characters',
    bcErrSettings: 'Values must be non-negative integers; rates must be at least 1',
    bcErrNoTg: 'Set your Telegram numeric ID first via "Telegram ID" at the bottom left',
    bcErrPreviewBlocked: 'Preview failed: send /start to the selected bot first, then retry',
    bcErrStatus: 'Not allowed in the current status; refresh and retry',
    bcErrStale: 'The campaign was changed by someone else; reloaded the latest version',
    myTg: 'Telegram ID',
    myTgTitle: 'Profile · Telegram numeric ID',
    myTgTip: 'Used to receive "Send me a preview" for broadcasts. Enter your Telegram numeric ID (message @userinfobot in Telegram to get it) and send /start to the bot you preview with. Save empty to remove it.',
    myTgLabel: 'Telegram numeric ID',
    myTgPh: 'e.g. 123456789',
    myTgErr: 'Telegram numeric ID must be 5–20 digits',
    myTgSaved: 'Telegram numeric ID saved',
    myTgCleared: 'Telegram numeric ID removed',
  },
};
